function convertOiMlToLinks() {
    $('oi\\:ml').each(function () {
        // Skip oi:ml elements inside label-sizer divs (prevents duplicate elements)
        if ($(this).closest('.label-sizer').length > 0) {
        $(this).remove();
        return;
        }

        const key = $(this).attr('key');
        const args = $(this).attr('args');
        const url =
        getContextPath() +
        '/eapp/messageresourcelookup?type=JSON&key=' +
        key +
        '&args=' +
        args;
        const holder = $(this).parent();
        let responder = '';

        if (holder.attr('data-responder-id') !== 'undefined') {
        responder =
            " data-responder-id='" + holder.attr('data-responder-id') + "' ";
        }
        const content = $(
        '<a class="iconGlossary" ' +
            responder +
            'aria-label="Learn More"  href="' +
            url +
            '">' +
            $(this).html() +
            '</a>',
        );

        // When oi:ml is used within a form group with a select element, we need to place the link before the select for proper styling, and move any required symbol along with it. 
        // Otherwise, just replace the oi:ml element with the link.
        var formGroup = $(this).closest('.form-outline.form-group');
        if (formGroup.length > 0 && formGroup.find('select').length > 0) {
        var selectEl = formGroup.find('select').first();
        var allRequired = formGroup.find('.requiredSymbol');
        var requiredSpan = allRequired.first().detach();

        content.insertBefore(selectEl);
        if (requiredSpan.length > 0) {
            requiredSpan.insertBefore(selectEl);
        }
        $(this).remove();
        } else {
        $(this).replaceWith(content);
        }

    });
}
